import { omit, cloneDeep } from 'lodash-es';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcUploadTree',
  props: {
    action: {
      type: String,
      default: '/ermsapi/sysobject/upload',
    },
    replaceFields: {
      type: Object,
      default: () => {
        return {};
      },
    },
    defaultFileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    data: {
      type: Object,
      default: () => {
        return { relativePath: '' };
      },
    },
    headers: {
      type: Object,
      default: () => {
        return {
          authorization: 'multipart/form-data',
        };
      },
    },
    uploadListConfig: {
      type: Object,
      default: () => {
        return {
          canRemove: true,
          icon: '',
          color: '',
          canUpload: true,
          leafColor: '',
        };
      },
    },
    //是否多选
    multiple: {
      type: Boolean,

      default: false,
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultSelectedKey: {
      type: String,
      default: '',
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      selectedKeys: [],
      selectedKey: '', //已选中的节点key
      relativePath: '', //上传路径
      expandedKeys: [],
      treeDataTransform: [],
      isMounted: false,
    };
  },
  methods: {
    // 点击叶子节点的回调
    clickLeaf(item) {
      this.$emit('clickLeaf', item);
    },
    onSelect(selectedKeys, info) {
      const { key } = info.node.dataRef;
      this.selectedKey = key;
      this.selectedKeys = [key];
    },
    uploadFile(item) {
      this.relativePath = item.dataRef.relativePath;
    },
    async deleteFile(node) {
      console.log('deleteFile---', node);
      this.deleteNodeByKey(this.treeDataTransform, node.dataRef.key);
      // console.log(cloneDeep(this.treeDataTransform));
    },
    // 定义一个递归函数，用于删除指定 key 的节点
    deleteNodeByKey(treeDataTransform, keyToDelete, level = 1) {
      // console.log('deleteNodeByKey---', cloneDeep(treeDataTransform), keyToDelete, level);
      if (treeDataTransform) {
        for (let i = 0; i < treeDataTransform.length; i++) {
          if (
            treeDataTransform[i].key === keyToDelete ||
            treeDataTransform[i].uid === keyToDelete
          ) {
            // console.log('匹配---', cloneDeep(treeDataTransform)[i].key, cloneDeep(treeDataTransform)[i].uid, keyToDelete);
            treeDataTransform.splice(i, 1); // 找到匹配的节点并删除
            return true; // 返回 true 表示删除成功
          } else if (treeDataTransform[i].children && treeDataTransform[i].children.length > 0) {
            // 如果有子节点，则递归调用该函数
            if (this.deleteNodeByKey(treeDataTransform[i].children, keyToDelete, level + 1)) {
              // console.log('deleteNodeByKey---',1);
              this.deleteNodeByKey(treeDataTransform[i].fileList, keyToDelete, level + 1);
              // console.log('deleteNodeByKey---',2);
              this.deleteNodeByKey(treeDataTransform[i].fileListCopy, keyToDelete, level + 1);
              // console.log('deleteNodeByKey---',3);
              return true; // 如果子节点删除成功，也返回 true
            }
          }
        }
      }

      return false; // 如果未找到匹配的节点，返回 false
    },
    // 点击父节点加载子节点
    async onLoadData(treeNode) {},

    //上传后的操作
    async handleChange(info) {
      const { locale } = this.configProvider;

      if (!(info.file && info.file.originFileObj && info.file.originFileObj.webkitRelativePath)) {
        // 获取进度
        const foundObject = info.fileList.find(obj => obj.uid === info.file.uid);
        if (foundObject) {
          if (info.event && info.event.percent) {
            foundObject.percent = info.event.percent;
            foundObject.isProgress = true;
          } else {
            foundObject.isProgress = false;
          }
        }
        // 获取上传文件的实时状态
        let uploadList = [];
        info.fileList.forEach(item => {
          const { response } = item;
          uploadList.push({
            title: item.name,
            key: item.uid,
            scopedSlots: { title: 'leaf' },
            percent: item.percent,
            isProgress: item.isProgress,
            ...response,
            status: item.status,
            size: item.size,
            leaf: true,
          });
        });
        // 找到上传的节点
        const result = this.findDataByValueSetters(this.treeDataTransform, this.relativePath);
        // 实时更新进度
        if (result) {
          this.$set(result, 'fileList', info.fileList);
          if (!result.children) {
            this.$set(result, 'children', []);
          }
          if (!this.expandedKeys.some(item => item === result.key)) {
            this.expandedKeys.push(result.key);
          }
          result.children = result.children.filter(item => item.scopedSlots.title !== 'leaf');
          result.children = [...result.children, ...uploadList];
        }
        //上传成功
        if (info.file.response && (info.file.status === 'done' || info.file.status === 'error')) {
          let file = info.file;
          if (file.response.code === '200') {
            this.$abNotification.success({
              message: `操作成功`,
              description: `附件上传成功!`,
            });
          } else {
            result.children = result.children.filter(item => {
              return item.key !== info.file.uid;
            });
            result.fileList = result.fileList.filter(item => item.uid !== info.file.uid);
            result.fileListCopy = result.fileList.filter(item => item.uid !== info.file.uid);
            if (
              (info.file.status == 'done' || info.file.status == 'error') &&
              info.file &&
              info.file.code != '200'
            ) {
              this.$abNotification.error({
                message: `操作失败`,
                description: `${info.file.response.message}`,
              });
              return false;
            }
          }
        }
      } else {
        // 获取进度
        const foundObject = info.fileList.find(obj => obj.uid === info.file.uid);
        if (foundObject) {
          if (info.event && info.event.percent) {
            foundObject.percent = info.event.percent;
            foundObject.isProgress = true;
          } else {
            foundObject.isProgress = false;
          }
        }
        const result = this.findDataByValueSetters(this.treeDataTransform, this.relativePath);
        const createDirectory = (directoryData, pathName) => {
          let existingDirectory = directoryData.find(item => item.relativePath === pathName);
          if (!existingDirectory) {
            existingDirectory = {
              title: pathName,
              key: result.relativePath + pathName,
              relativePath: pathName,
              scopedSlots: { title: 'custom' },
              children: [],
              fileList: [], // 添加 fileList 属性
            };

            directoryData.push(existingDirectory);
          }

          return existingDirectory;
        };

        let parts = foundObject.originFileObj.webkitRelativePath.split('/');
        if (!result.children) {
          result.children = [];
        }

        let finalDirectory = result;

        for (let i = 0; i < parts.length - 1; i++) {
          finalDirectory = createDirectory(finalDirectory.children, parts[i]);
        }
        // 确保 finalDirectory.fileList 存在
        if (!finalDirectory.fileList) {
          finalDirectory.fileList = [];
        }
        // 同时往 children 和 fileList 中 push 数据
        finalDirectory.children.push({
          title: foundObject.name,
          key: foundObject.uid,
          scopedSlots: { title: 'leaf' },
          percent: foundObject.percent,
          isProgress: foundObject.isProgress,
        });

        finalDirectory.fileList.push(foundObject);
      }
      this.$emit('change', info);
    },
    // 找到添加文件的节点
    findDataByValueSetters(treeDataTransform, targetValueSetters) {
      for (const node of treeDataTransform) {
        if (node.relativePath === targetValueSetters) {
          // 如果找到匹配的节点，返回该节点的数据
          return node;
        }

        // 如果当前节点有子节点，递归搜索子节点
        if (node.children && node.children.length > 0) {
          const result = this.findDataByValueSetters(node.children, targetValueSetters);
          if (result) {
            return result; // 返回找到的数据
          }
        }
      }
      // 如果未找到匹配的节点，返回 null
      return null;
    },
    findNodeAndParentByKey(nodes, targetKey, parent = null) {
      for (const node of nodes) {
        if (node.key === targetKey) {
          return parent; // 找到了目标节点，返回其父节点
        }
        if (node.children && node.children.length > 0) {
          const result = this.findNodeAndParentByKey(node.children, targetKey, node);
          if (result) {
            return result; // 在子节点中找到了目标节点，返回其父节点
          }
        }
      }
      return null; // 没有找到目标节点
    },
    findNodeByKey(nodes, targetKey) {
      for (const node of nodes) {
        if (node.key === targetKey) {
          return node; // 找到了目标节点，返回它本身
        }
        if (node.children && node.children.length > 0) {
          const result = this.findNodeByKey(node.children, targetKey);
          if (result) {
            return result; // 在子节点中找到了目标节点，返回它本身
          }
        }
      }
      return null; // 没有找到目标节点
    },
    async before(file, fileList, item) {
      //获取拦截的节点upload组件
      let node = this.findNodeByKey(this.treeDataTransform, this.selectedKeys[0]);
      // 判断格式是否是支持的
      const fileType = file.name
        .trim()
        .split('.')
        .pop()
        .toLowerCase();
      if (
        this._props.accept &&
        this._props.accept != '*' &&
        !this._props.accept
          .trim()
          .replace(/\./g, '')
          .split(',')
          .includes(fileType)
      ) {
        this.$abNotification.error({
          message: `提示`,
          description: `文件“${file.name}”上传失败，格式不正确！`,
        });
        return Promise.reject();
      }
      let returnValue = true;
      if (!this.$listeners.before) {
        returnValue = true;
        node.fileListCopy = [...node.fileListCopy, file];
        return returnValue ? Promise.resolve() : Promise.reject();
      } else {
        returnValue = await new Promise((resolve, reject) => {
          this.$emit('before', file, fileList, item, data => {
            resolve(data); // 或者 reject(data);
          });
        });
        //如果是阻拦掉的 不放入已上传列表
        if (returnValue) {
          node.fileListCopy = [...node.fileListCopy, file];
        }
        return returnValue ? Promise.resolve() : Promise.reject();
      }
    },
    confirm(item) {
      let parent = this.findNodeAndParentByKey(this.treeDataTransform, this.selectedKeys[0]);
      if (parent) {
        parent.fileList = parent.fileList.filter(p => {
          return p.uid !== this.selectedKeys[0];
        });
        parent.fileListCopy = parent.fileListCopy.filter(p => {
          return p.uid !== this.selectedKeys[0];
        });
      }
      this.$emit('syncDeleteFile', item);
    },
    cancel() {},
    handleExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
    },
    remove(item) {
      this.confirm(item);
    },
    processTreeData(treeDataTransform) {
      treeDataTransform.forEach(obj => {
        if (
          obj.scopedSlots &&
          (obj.scopedSlots.title === 'custom' || obj.scopedSlots.title === 'leaf')
        ) {
          if (obj.children && obj.children.length > 0) {
            this.processTreeData(obj.children);
            const leafNodes = obj.children.filter(
              child => child.scopedSlots && child.scopedSlots.title === 'leaf',
            );
            if (leafNodes.length > 0) {
              obj.fileList = leafNodes.map(node => {
                return {
                  uid: node.key,
                  name: node.name,
                  status: 'done',
                  response: node,
                  path: node.path,
                };
              });
              obj.fileListCopy = leafNodes.map(node => {
                return {
                  uid: node.key,
                  name: node.name,
                  status: 'done',
                  response: node,
                  path: node.path,
                };
              });
            }
          } else {
            obj.fileListCopy = [];
          }
        } else {
          if (obj.children && obj.children.length > 0) {
            obj.fileListCopy = [];
            this.processTreeData(obj.children);
          }
        }
      });
    },
  },
  mounted() {
    let treeData = JSON.parse(JSON.stringify(this.treeData));
    this.processTreeData(treeData);
    this.treeDataTransform = treeData;
    this.selectedKeys = [this.defaultSelectedKey];
    this.isMounted = true;
  },
  render() {
    const {
      action,
      replaceFields,
      defaultFileList,
      data,
      headers,
      treeData,
      treeDataTransform,
      selectedKeys,
      expandedKeys,
      uploadListConfig,
      multiple,
      isMounted,
      $scopedSlots,
    } = this;
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-upload-tree');
    uploadListConfig.canRemove =
      uploadListConfig.canRemove === undefined ? true : uploadListConfig.canRemove;
    uploadListConfig.canUpload =
      uploadListConfig.canUpload === undefined ? true : uploadListConfig.canUpload;
    return (
      <div class={prefixCls}>
        <a-tree
          key={isMounted}
          slot="content"
          show-line={false}
          show-icon={false}
          tree-data={treeDataTransform}
          selectedKeys={selectedKeys}
          replace-fields={replaceFields}
          load-data={this.onLoadData}
          defaultExpandedKeys={expandedKeys}
          defaultExpandAll
          onExpand={this.handleExpand}
          onSelect={this.onSelect}
          scopedSlots={{
            custom: item => (
              <div class="custom">
                <span title={item.title}>{item.title}</span>
                <div class="button iconClass">
                  <a-upload
                    {...{
                      props: omit(
                        item,
                        'showUploadList',
                        'fileList',
                        'data',
                        'defaultFileList',
                        'headers',
                        'action',
                        'multiple',
                        'beforeUpload',
                      ),
                    }}
                    action={item.action || action}
                    headers={item.headers || headers}
                    multiple={multiple}
                    default-file-list={item.defaultFileList || defaultFileList}
                    fileList={item.fileListCopy}
                    data={item.data || data}
                    showUploadList={false}
                    beforeUpload={(file, fileList) => this.before(file, fileList, item)}
                    onChange={this.handleChange}
                  >
                    {uploadListConfig.canUpload && (
                      <fc-icon
                        className="FCupload-2"
                        class="iconClass"
                        size="16px"
                        onClick={() => this.uploadFile(item)}
                        style={{
                          display: item =>
                            item.scopedSlots && item.scopedSlots.title === 'custom'
                              ? 'block'
                              : 'none',
                        }}
                      ></fc-icon>
                    )}
                  </a-upload>
                </div>
              </div>
            ),
            leaf: item => (
              <div class="leafContainer">
                <div
                  class={`button leaf`}
                  title={item.title}
                  onClick={() => {
                    this.clickLeaf(item);
                  }}
                >
                  <span class="tag">{$scopedSlots.tag ? $scopedSlots.tag(item) : null}</span>
                  <span
                    class={`${item.isProgress ? 'uploadingTitle' : 'uploadingTitleAll'}`}
                    style={`color: ${uploadListConfig.leafColor ? uploadListConfig.leafColor : ''}`}
                  >
                    {item.title}
                  </span>
                  {item.isProgress && (
                    <a-progress percent={item.percent} showInfo={false} class="progress" />
                  )}
                </div>
                <div class="iconClass">
                  {uploadListConfig.canRemove && (
                    // <a-popconfirm
                    //   title={locale.Popconfirm.okText + locale.Popconfirm.removeFile + '?'}
                    //   ok-text={locale.Popconfirm.okText}
                    //   cancel-text={locale.Popconfirm.cancelText}
                    //   onConfirm={() => this.confirm(item)}
                    //   onCancel={this.cancel}
                    // >
                    <div class="button">
                      {/* <a-icon type="delete"/> */}
                      <fc-icon
                        onClick={() => {
                          this.remove(item);
                        }}
                        className={
                          uploadListConfig.icon
                            ? `${uploadListConfig.icon} btn`
                            : 'FCdelete-bin-2 btn'
                        }
                        size="16px"
                        color={uploadListConfig.color ? uploadListConfig.color : ''}
                      ></fc-icon>
                    </div>
                    // </a-popconfirm>
                  )}
                </div>
              </div>
            ),
          }}
        ></a-tree>
      </div>
    );
  },
};
